var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 6086"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    cx: 20.0001,
    cy: 19.9999,
    r: 18.5714,
    fill: "#01181B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 260",
    d: "M12.8569 20.7142L17.3807 25.238L27.3807 15.238",
    stroke: "#FEFEFE",
    strokeWidth: 2.38095,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTickIcon);
export default __webpack_public_path__ + "static/media/black-tick-icon.8be220b483ad60bfe7cf2afaab4f71d2.svg";
export { ForwardRef as ReactComponent };